import React, { Fragment, useContext, useEffect } from 'react';
import { H6, LI } from '../../../AbstractElements';
import ConfigDB from '../../../Config/ThemeConfig';
import CustomizerContext from '../../../_helper/Customizer';
import { Media } from 'reactstrap';
import barc from '../../../assets/images/layouts/barc.jpg';
import dubai from '../../../assets/images/layouts/dubai.jpg';
import london from '../../../assets/images/layouts/london.jpg';
import los from '../../../assets/images/layouts/los.jpg';
import madrid from '../../../assets/images/layouts/madrid.jpg';
import moscow from '../../../assets/images/layouts/moscow.jpg';
import newyork from '../../../assets/images/layouts/newyork.jpg';
import paris from '../../../assets/images/layouts/paris.jpg';
import romo from '../../../assets/images/layouts/romo.jpg';
import seoul from '../../../assets/images/layouts/seoul.jpg';
import singapore from '../../../assets/images/layouts/singapore.jpg';
import tokyo from '../../../assets/images/layouts/tokyo.jpg';
import { classes } from '../../../Data/Layouts';
import { useNavigate } from 'react-router';
import { getBrowserPathname } from '../../../utils/appPaths';

const CheckLayout = () => {
  const { addSidebarLayouts } = useContext(CustomizerContext);
  const history = useNavigate();
  const sidebarSettings = ConfigDB.data.sidebar_setting || localStorage.getItem('sidebar_Settings');

  useEffect(() => {
    ConfigDB.data.settings.sidebar_setting = sidebarSettings;
  }, []);

  const handlePageLayputs = (type) => {
    let key = Object.keys(type).pop();
    let val = Object.values(type).pop();
    const pathname = getBrowserPathname();
    const url = pathname.slice(0, pathname.lastIndexOf('/'));
    const modifyURL = url + '/' + Object.keys(type);
    addSidebarLayouts(val);
    localStorage.setItem('layout', key);
    history(modifyURL);
  };

  return (
    <Fragment>
      <ul className='sidebar-type layout-grid layout-types'>
        {/* attrUL={{ className: "sidebar-type layout-grid layout-types" }}  */}
        <LI attrLI={{ dataattr: 'compact-sidebar', onClick: (e) => handlePageLayputs(classes[0]) }}>
          {/* // onClick={(e) => handlePageLayputs(classes[0])} */}

          <div className='layout-img'>
            {' '}
            <Media src={dubai} className='img-fluid' alt='' />
            <H6>Dubai</H6>
          </div>
        </LI>
        <LI
          attrLI={{ dataattr: 'modern-layout', onClick: (e) => handlePageLayputs(classes[2]) }}
          // onClick={(e) => handlePageLayputs(classes[2])}
        >
          <div className='layout-img'>
            <Media src={seoul} className='img-fluid' alt='' />
            <H6>Los Angeles</H6>
          </div>
        </LI>
        <LI
          attrLI={{ dataattr: 'material-layout', onClick: (e) => handlePageLayputs(classes[3]) }}
          // onClick={(e) => handlePageLayputs(classes[3])}
        >
          <div className='layout-img'>
            <Media src={los} className='img-fluid' alt='' />
            <H6>Paris</H6>
          </div>
        </LI>
      </ul>
    </Fragment>
  );
};

export default CheckLayout;
